function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M17.57 1.5H2.43a.93.93 0 00-.93.94v15.12a.93.93 0 00.93.94h8.15v-6.58H8.37V9.35h2.22V7.46a3.09 3.09 0 013.3-3.39 17.52 17.52 0 012 .1v2.3h-1.38c-1.07 0-1.27.51-1.27 1.25v1.63h2.54l-.33 2.57h-2.22v6.58h4.33a.93.93 0 00.93-.94V2.44a.93.93 0 00-.93-.94"
}));